import { render, staticRenderFns } from "./ExtraItem.vue?vue&type=template&id=14a553ca&scoped=true"
import script from "./ExtraItem.vue?vue&type=script&lang=js"
export * from "./ExtraItem.vue?vue&type=script&lang=js"
import style0 from "./ExtraItem.vue?vue&type=style&index=0&id=14a553ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a553ca",
  null
  
)

export default component.exports